<template>
  <div class="skeleton-box">
    <div class="search-box">
      <span class="search-item skeleton-item"></span>
      <span class="search-item skeleton-item"></span>
      <span class="search-item skeleton-item"></span>
      <span class="search-item skeleton-item"></span>
    </div>
    <div class="table-box">
      <div class="table-tr skeleton-item"></div>
      <div class="table-tr skeleton-item"></div>
      <div class="table-tr skeleton-item"></div>
      <div class="table-tr skeleton-item"></div>
      <div class="table-tr skeleton-item"></div>
      <div class="table-tr skeleton-item"></div>
      <div class="table-tr skeleton-item"></div>
      <!-- <div class="table-tr skeleton-item"></div>
      <div class="table-tr skeleton-item"></div>
      <div class="table-tr skeleton-item"></div> -->
    </div>
    <div>
      <div class="page skeleton-item"></div>
    </div>
  </div>
</template>
<script>
export default {
  
};
</script>
<style lang="less" scoped>
@keyframes skeleton-stripes {
  from {
    background-position: 0 0;
  }
  to {
    background-position: 20rem 0;
  }
}
.skeleton-item {
  background-color: #f2f2f2;
}
.skeleton-item.ske-ani {
  animation: skeleton-stripes 1s linear infinite;
  background: #f1f3f4 linear-gradient(90deg, rgba(255, 255, 255, 0.39) 25%, transparent 25%);
  background-size: 20rem 20rem;
}
.skeleton-box {
  background-color: #fff;
  padding: 40px;
}
.search-box {
  margin-bottom: 20px;
  .search-item {
    display: inline-block;
    width: 190px;
    height: 30px;
    margin-right: 20px;
    &:last-child {
      width: 60px;
    }
  }
}
.table-box {
  margin-bottom: 10px;
  .table-tr {
    width: 100%;
    height: 40px;
    margin-bottom: 15px;
  }
}
.page {
  float: right;
  height: 40px;
  width: 200px;
}

</style>